module.exports = __webpack_public_path__ + "img/linktree.f6407784.svg";